import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

export type ReadUnreadType = 'read' | 'unread' | 'show_all';

export type ReadUnreadState = {
  readUnread: ReadUnreadType;
};

const initialState: ReadUnreadState = {
  readUnread: 'show_all',
};

const readUnreadFilterSlice = createSlice({
  name: 'readUnreadFilter',
  initialState,
  reducers: {
    updateReadUnreadSelection: (
      state,
      action: PayloadAction<ReadUnreadType>,
    ) => {
      state.readUnread = action.payload;
    },
    resetReadUnreadSelection: (state) => {
      state.readUnread = initialState.readUnread;
    },
  },
});

export const getReadUnread = (state: RootState) => state.readUnreadFilter;

export const { updateReadUnreadSelection, resetReadUnreadSelection } =
  readUnreadFilterSlice.actions;

export default readUnreadFilterSlice.reducer;
